import MultiChoiceSearchField from './MultiChoiceSearchField';

/**
 * ListCombo
 * Props:
 * - type: 'group' | 'entity' (détermine l'appel API par défaut)
 * - fetcher: optional function(parentIdArray, type) => Promise<array> (si fourni, utilisé à la place des helpers)
 * - parentIdArray: array optionnel passé à l'API
 * - apiType: optionnel, passé en second paramètre aux helpers (ex: 'someType')
 * - multiple: boolean, permet la sélection multiple
 * - value: valeur contrôlée (id ou array d'id) 
 * - onChange: function(newValue) appelé avec id ou array d'id
 * - labelField: nom du champ label dans les items (défaut 'label' ou 'name')
 * - valueField: nom du champ id dans les items (défaut 'id')
 * - placeholder: texte d'aide pour l'option vide
 */
const ListCombo = ({
    application, comboApplication, category, name, label, source,
    multiple = false,
    labelField = 'label',
    valueField = 'id',
    placeholder = 'Select...',
    disabled = false,
    area = ''
}) => {
    const listApplication = comboApplication || application;

    return (
        <MultiChoiceSearchField
            application={application}
            comboApplication={listApplication}
            category={category}
            name={name}
            label={label}
            source={source}
            area={area}
            labelField={labelField}
            valueField={valueField}
            multiple={multiple}
            placeholder={placeholder}
            disabled={disabled}
        />
    );
};

export default ListCombo;
